import { render, staticRenderFns } from "./UserVouchers.vue?vue&type=template&id=4a46d116&"
import script from "./UserVouchers.vue?vue&type=script&lang=js&"
export * from "./UserVouchers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports